var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99922 11.4H7.39922C5.63202 11.4 4.19922 9.9672 4.19922 8.2V1.8C4.19922 1.3584 4.55762 1 4.99922 1H11.3992C11.8408 1 12.1992 1.3584 12.1992 1.8V8.2C12.1992 9.9672 10.7664 11.4 8.99922 11.4Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20078 11.4V14.6",
    stroke: "white",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80078 14.6H10.6008",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1992 3.39999H14.5992C15.0408 3.39999 15.3992 3.75839 15.3992 4.19999V5.79999C15.3992 7.12559 14.3248 8.19999 12.9992 8.19999H12.1992",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2 3.39999H1.8C1.3584 3.39999 1 3.75839 1 4.19999V5.79999C1 7.12559 2.0744 8.19999 3.4 8.19999H4.2",
    stroke: "white",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityIcon);
export default __webpack_public_path__ + "static/media/activity-icon.ab17b1cdcfa5ddb8916bf7c45472b553.svg";
export { ForwardRef as ReactComponent };